import { Injectable } from '@angular/core';


import { Item } from '../../../../bayadic-shared-models/classes/item/Item';
import { StorageManagerProvider } from '../../../../providers/storage-manager/storage-manager';
import { AjaxBridgeProvider } from '../../../../providers/ajax-bridge/ajax-bridge';
import { SocketManagerProvider } from '../../../../providers/socket-manager/socket-manager';
import { UserManagerProvider } from '../../../../providers/user-manager/user-manager';
import { ItemsManagerProvider } from '../../../../providers/items-manager/items-manager';
import { FriendsManagerProvider } from '../../../../providers/friends-manager/friends-manager';
import { AdsService } from '../../../../providers/ads-manager/ads-service';
import { Chat } from '../../../../bayadic-shared-models/chat/Chat';
import { User } from '../../../../bayadic-shared-models/classes/user/User';
import { Member } from '../../../../bayadic-shared-models/classes/system/member/Member';
import { AbstractChatMessage } from '../../../../bayadic-shared-models/classes/message/abstract-chat-message';
import * as Enums from '../../../../bayadic-shared-models/enums/Enums';
import * as Tools from '../../../../bayadic-shared-models/tools/Tools';
import { Synchronizer } from '../../../../providers/chats-manager/components/synchronizer/Synchronizer';
import { MembersManagerProvider } from '../../../../providers/members-manager/members-manager';
import { Events } from '../../../../providers/events/events';
import { MessageBuilder } from '../../chat/components/chat/chat-input/message-builder';
import { MessageFactory } from '../../chat/components/chat/chat-input/message-factory';
import { Message } from '../../../../bayadic-shared-models/messages/message';
import { DictionaryMessage } from '../../../../bayadic-shared-models/classes/message/DictionaryMessage';
import { ChatMessage } from '../../../../bayadic-shared-models/classes/message/chat-message';
import { LeitnerMessage } from '../../../../bayadic-shared-models/classes/message/LeitnerMessage';
import { AddMessageRequest } from '../../../../bayadic-shared-models/item/add-message-request';
import { AddMessageResponse } from '../../../../bayadic-shared-models/item/add-message-response';
import { ChatsDatabaseService } from '../../../../providers/chats-database-service/chats-database-service';
import { ACTIONS } from '../../../../bayadic-shared-models/enums/Enums';
import { MessageData } from '../../../../bayadic-shared-models/classes/message/message-data';
import { GetSectionRequest } from '../../../../bayadic-shared-models/item/get-sections-request';
import { GetSectionResponse } from '../../../../bayadic-shared-models/item/get-sections-response';
import { delay, Observable, of, take, timeout, withLatestFrom } from 'rxjs';
import { ChatFront } from '../../chat/ChatFront';
import { QuizMessage } from '../../../../bayadic-shared-models/classes/quiz/quiz-message';
import { LoggerService } from '../../../../app/services/logger.service';
import { RemoveAllQuizMessagesRequest } from '../../../../bayadic-shared-models/item/remove-all-quiz-messages-request';
import { RemoveAllQuizMessagesResponse } from '../../../../bayadic-shared-models/item/remove-all-quiz-messages-response';
import { ITEM_TYPES } from '../../../../bayadic-shared-models/item/item-types';
import { SubscriptionService } from '../../../../providers/subscription-manager/subscription-service';
import { NavController } from '@ionic/angular';
import { NavigationService } from '../../../services/navigation.service';
@Injectable()
export class ChatsManagerProvider {
  async removeMessagesUntilNoQuiz(chat: Chat) {
    if(chat.type === ITEM_TYPES.Quiz){
      const result = await this.removeAllQuizMessagesCloud(chat);
      if(result){
        await this.removeAllQuizMessagesLocally(chat);
      }
    }
    
  }
    async removeAllQuizMessagesCloud(chat: Chat) {
        const result = await this.socketManager.asyncQuery<RemoveAllQuizMessagesResponse, RemoveAllQuizMessagesRequest>(ACTIONS.removeAllQuizMessages, { chatID: chat.chatID });
        return result.success;
    }
    async removeAllQuizMessagesLocally(chat: Chat) {
        for(let message of chat.messages){
            if(message.messageType === 'quiz'){
                await this.databaseService.deleteMessage(chat, message);
            }
        }
        chat.messages.length = 0;
    }
  showAllAnswers: boolean = false;
  toggleShowAllAnswers() {
    this.logger.debug('toggleShowAllAnswers');
    this.showAllAnswers = !this.showAllAnswers;
  }
    showMessagesForToday(chat: Chat) {
        chat.messages.length = 0;
        // chat.messages = await this.databaseService.readPagesOfTodayScheduledMessage(chat, 10, 1)

    }

    public items: Array<Item> = [];
    public chats: Array<Chat> = [];
    public currentChat: Chat;
    public synchronizer: Synchronizer;
    public messageBuilder: MessageBuilder;
    public messageFactory: MessageFactory;
    public addedMessagesNumber = 0;
    public static get updateChatTitleAction() { return "updateChatTitle"; };
    constructor(
        public storageManager: StorageManagerProvider,
        public databaseService: ChatsDatabaseService,
        public ajaxBridge: AjaxBridgeProvider,
        public itemsManager: ItemsManagerProvider,
        public friendsManager: FriendsManagerProvider,
        public membersManager: MembersManagerProvider,
        public adsManager: AdsService,
        public logger: LoggerService,
        public subscriptionService: SubscriptionService,

        //            public navCtrl : NavController,
        public socketManager: SocketManagerProvider,
        public events: Events,
        public userManager: UserManagerProvider,
        public navCtrl: NavigationService
    ) {
        this.synchronizer = new Synchronizer(this, this.logger);
        this.clearCurrentChat();
        this.messageBuilder = new MessageBuilder()
        this.messageFactory = new MessageFactory();

    }
    initItems() {

    }
    async addMessageToChat(chat: Chat, message: LeitnerMessage | ChatMessage | DictionaryMessage) {
        chat.addMessage(message);
        this.addMessageToCloud(chat, message).then(async addMsgResult=>{
            if (addMsgResult.created) {
                message.setStatus(message.possibleStatuses.receivedByServer);
                message.setMessageID(addMsgResult.messageData.messageID);
                message.timestamp = addMsgResult.messageData.timestamp;
                await this.databaseService.addMessage(chat, message.getMessageData())
                this.onMessageAdded();
            }
            return addMsgResult
        });
    }
    public async addMessageToCloud(chat: Chat, message: LeitnerMessage | ChatMessage | DictionaryMessage) {
        const requestData: AddMessageRequest = {
            message: { content: message.getContentString(), type: message.messageType },
            itemID: chat?.chatID
        };
        const addMsgResult = await this.socketManager.asyncQuery<AddMessageResponse, AddMessageRequest>(ACTIONS.addMessage, requestData);
        return addMsgResult;
    }

    leaveGroup(itemLeave: Item) {

        this.socketManager.asyncQuery("leaveChat", { 'chat': itemLeave.chat.getSimpleModel() }).then(response => {
            this.itemsManager.deleteItemLocally(itemLeave);
            let member = new Member(this.userManager.user.getUserObject());
            this.membersManager.removeMember(member, itemLeave.chat);
            // this.navCtrl.navigateRoot("root");
        })
    }
    setAllChatsView(isLoaded) {
        this.chats.forEach(function (chat: Chat) {
            chat.setViewLoaded(isLoaded);
        });
    }
    searchInChat(needle: string) {
        this.databaseService.selectMessagesFromChat(this.currentChat, needle).then(messages => {
            this.currentChat.searchIn(messages);
        });
    }
    handleMessage(res) {
        let result = JSON.parse(res);
        let messageObject = JSON.parse(result['msg']);
        //            this.consoleDialog.log("-----------------",messageObject);
        if (result['owner'] == "getMessage") {
            this.loadChatMessage(result, messageObject);
        }
    }
    private loadChatMessage(result: any, messageObject: any) {
        this.getChat(result['query']['data']['item']['itemID']).then(chat => {
            //                    messageObject.type = messageObject.messageType;
            //                    let message = new Message(messageObject);
            let message = this.createMessageWithMessageObject(messageObject);
            if (message.from.userID != this.userManager.user.userID)
                message.received = true;
            else {
                message.received = false;
            }
            // if (this.platform.is("cordova")) {
            //     this.databaseService.addMessage(chat, message.getMessageData());
            // }
            //                    message.receivedTime = new Date().toString().split(" GMT+0100")[0];
            chat.addMessage(message);
            this.events.publish("scrollDown");


        });
    }

    async initChat(item: Item): Promise<Chat> {
        if (item.chat) {
            item.chat.item = item;
            return item.chat;
        }
        await this.databaseService.createTablesIfNotExists(item.itemID)
        const chatObject = await this.storageManager.get(item.itemID)
        if (chatObject) {
            item.chat = new Chat(chatObject);
        }
        else {
            item.chat = new Chat(item);
        }
        //@ts-ignore
        item.chat.chatID = item.itemID ?? item.chatID;
        item.chat.item = item;
        item.chat.type = item.type;
        this.getSections(item.chat);
        return item.chat;
    }

    updateChatTitle(chat: Chat) {
        this.socketManager.asyncQuery(ChatsManagerProvider.updateChatTitleAction, chat.getSimpleModel());
    }
    async updateChat(item: Item): Promise<Chat> {
        const chat = await this.initChat(item)
        await this.synchronizer.getNewMessages(chat);
        await this.getSections(chat);
        return chat;
    }
    async getSections(chat: Chat) {
        // First try to get sections from localStorage
        const storageKey = `sections_${chat.chatID}`;
        let sectionsStr = await this.storageManager.get(storageKey);
        let sections = sectionsStr ? JSON.parse(sectionsStr) : null;
        
        if (sections && sections.sections && sections.sections.length > 0) {
            chat.sections = sections.sections;
            
            // Check if any section is marked as current, if not set the latest one
            const hasCurrent = chat.sections.some(section => section.current);
            if (!hasCurrent && chat.sections.length > 0) {
                chat.sections[chat.sections.length - 1].current = true;
            }
        }
        
        // Asynchronously get sections from server in the background
        this.socketManager.asyncQuery<GetSectionResponse, GetSectionRequest>(
            ACTIONS.getSections, 
            { itemID: chat.chatID }
        ).then(serverSections => {
            if (serverSections && serverSections.sections && serverSections.sections.length > 0) {
                // Save sections to localStorage for future use
                this.storageManager.set(storageKey, JSON.stringify(serverSections));
                
                // Merge server sections with existing ones, avoiding duplicates
                const existingSectionIds = new Set(chat.sections.map(s => s.startingMessageID));
                const newSections = serverSections.sections.filter(s => !existingSectionIds.has(s.startingMessageID));
                
                if (newSections.length > 0) {
                    chat.sections = [...chat.sections, ...newSections];
                }
                
                // Check if any section is marked as current, if not set the latest one
                const hasCurrent = chat.sections.some(section => section.current);
                if (!hasCurrent && chat.sections.length > 0) {
                    chat.sections[chat.sections.length - 1].current = true;
                }
            }
        }).catch(error => {
            console.error('Error fetching sections from server:', error);
        });
    }
    findChat(chatID: string) {
        let chat: Chat = null;
        for (let item of this.itemsManager.items) {
            if (item.chat) {
                if (item.chat.chatID == chatID)
                    chat = item.chat;
            }
        }
        for (let item of this.itemsManager.publicItems) {
            if (item.chat) {
                if (item.chat.chatID == chatID)
                    chat = item.chat;
            }
        }
        return chat;
    }
    async reload(chat: Chat): Promise<void> {
        const chatObject = await this.storageManager.get(chat.chatID)
        let myChat = new Chat(chatObject);
        chat = myChat;
        if (chat.isReviewWords()) {
            this.initChat(chat.item);
        }
    }
    async getMessageContent(message: AbstractChatMessage) {
        const result = await this.databaseService.getMessageContent(message);
        return result;
    }
    saveMessageContent(chat: Chat, message: AbstractChatMessage) {
        this.databaseService.updateMessageContent(chat.chatID, message);
    }

    addMember(chat: Chat, friend) {
        this.logger.debug('chatsManager addmember:', friend);

        chat.members.push(friend);
        let requestData = { chat: chat.getSimpleModel(), member: friend.getSimpleModel() };
        this.logger.debug('chat: chat.getSimpleModel() V member: friend.getSimpleModel() :', requestData);

        this.socketManager.asyncQuery("addMember", requestData);
    }
    removeMember(chat: Chat, member: Member) {
        //      chat.members.push(friend);
        let memberIndex = chat.members.indexOf(member);
        chat.members.splice(memberIndex, 1);
        let requestData = { chat: chat.getSimpleModel(), member: member.getSimpleModel() };
        this.socketManager.asyncQuery("removeMember", requestData);
        this.membersManager.removeMember(member, chat);
    }
    async removeMessage(message: AbstractChatMessage, chat: Chat) {
        await this.synchronizer.removeMessage(message, chat);
        await this.databaseService.deleteMessage(chat, message);
        //     chat.setInSortedMessages();

    }
    shareMessage(message, chat) {
        //      let messageContent = message.exportMsg();
        //      this.socialSharing.share(messageContent, this.message.text);
    }
    getMembersAjax(chat: Chat) {
        return new Promise((resolve, reject) => {
            this.socketManager.asyncQuery("getMembers", chat).then(result => {
                for (let memberObjectIndex in result['members']) {
                    let friend = new Member(result['members'][memberObjectIndex])
                    chat.members.push(friend);
                }
                resolve(chat);
            }).catch(err => {
                reject(err);
            });
        });
    }
    getMembers(chat: Chat) {
        this.socketManager.asyncQuery("getMembers", chat.getSimpleModel());
    }
    getChat(chatID: string): Promise<Chat> {
        return new Promise(async (resolve) => {
            let chat: Chat;
            if (this.findChat(chatID)) {
                resolve(this.findChat(chatID));
            }
            else {
                const chatObject = await this.storageManager.get(chatID)
                chat = new Chat(chatObject);
                resolve(chat);
            }
        });
    }
    getLeitnerChat(): Promise<Chat> {
        return new Promise((resolve) => {
            let leitnerItem: Item;
            this.itemsManager.items.forEach(function (item) {
                if (item.type == "leitner")
                    leitnerItem = item;
            });
            let chat: Chat;
            this.storageManager.get(leitnerItem.itemID).then(chatObject => {
                chat = new Chat(chatObject);
                resolve(chat);
            });
        });

    }
    appendMessageToChat(messageData, chat: Chat) {
        if (!chat) {
            return false;
        }
        let message = this.createMessageWithMessageObject(messageData);
        message.setMessageTimeSent(messageData.timeSent);
        if (message.from.userID != this.userManager.user.userID)
            message.received = true;
        else {
            message.received = false;
        }
        message.receivedTime = Tools.Time.getTimeString();
        chat.addMessage(message);
        //                    this.consoleDialog.log2("compare",this.currentChat.chatID+", "+chat.chatID);
        if (this.currentChat.chatID != chat.chatID && !message.hasBeenSeenByMe()) {
            chat.unreadMessagesNumber++;
        }
        this.events.publish("scrollDown");
    }
    prependMessageToChat(messageData: Message, chat: Chat) {
        const message = this.buildMessage(messageData);
        chat.prependMessage(message);
        this.databaseService.addMessage(chat, message.getMessageData())
    }
    private buildMessage(messageData: Message) {
        const messageBuilder = new MessageBuilder();
        const message = messageBuilder
            .type(messageData.messageType)
            .content(messageData.content)
            .messageID(messageData.messageID)
            .time(messageData.timeSent)
            .build();
        return message;
    }
    public buildMessageFromMessageData(messageData: MessageData<any>) {
        if (!messageData.timestamp) throw new Error("no time stamp found for " + messageData.content)
        const messageBuilder = new MessageBuilder();
        const user = new User({ userID: messageData.from });
        const message = messageBuilder
            .type(messageData.messageType)
            .content(messageData.content)
            .from(user)
            .messageID(messageData.messageID)
            .chatID(messageData.itemID)
            .scheduledTime(messageData.scheduledTime)
            .time(messageData.timestamp)
            .build();
        return message;
    }
    clearCurrentChat() {
        this.currentChat = new Chat({});
        this.currentChat.id = 123;
    }
    setCurrentChat(chat: Chat) {
        this.currentChat = chat;
    }

    onMessageAdded() {
        this.addedMessagesNumber++;
        if (this.addedMessagesNumber == 3 || this.addedMessagesNumber == 8 || this.addedMessagesNumber % 14 == 0) {
            this.adsManager.setAdsNeeded(true);
        }
    }

      scrollToMessage(chat: Chat, messageID: string): Promise<boolean> {
        return new Promise((resolve, reject)=>{

        const message = chat.messages.find(m => m.messageID === messageID);
        // get 10 messags before and after the message
        const loadMessagesNumber = 4
        const distance = loadMessagesNumber*2
        const topIndex = chat.messages.indexOf(message)-loadMessagesNumber
        const bottomIndex = topIndex +distance

        const messages = this.readMessageByIndex(topIndex, distance, chat);
        // empty chat messages$
        chat.messages = messages;
        resolve(true);
        })

      }

      async loadOldMessages(chat: Chat) {
        const pageSize = 20;
        if(chat.isLesson()){
            for(let i=0; i< 5; i++){
                const olderMessages = await this.synchronizer.getOlderMessages(chat, pageSize);
                if(olderMessages && olderMessages.length === 0){
                    break;
                }
            }

        }
        else {
            await this.synchronizer.getOlderMessages(chat, pageSize);
        }
      }
      getHeroMessages$(chat: ChatFront, pageSize: number = 30): Observable<AbstractChatMessage[]> {
        const messages = of(this.getMessagsByIndex(chat.bottomIndex, pageSize, chat)).pipe(delay(250));
        chat.bottomIndex+=pageSize;
        return messages;
      }
      getOlderHeroMessages$(chat: ChatFront, pageSize: number = 45): Observable<AbstractChatMessage[]> {
        const messages = of(this.getMessagsByIndex(chat.topIndex-pageSize, pageSize, chat)).pipe(delay(250));
        chat.topIndex-=pageSize;
        return messages
    }
    readMessageByIndex(index:number, count:number, chat: Chat): AbstractChatMessage[] {
        if(index<0){
            index = 0;
            count-=Math.abs(index);
        }
        const messagesToAdd = chat.messages.slice(index, index+count);
        return messagesToAdd;
    }

      getMessagsByIndex(index: number, count: number, chat: Chat): AbstractChatMessage[] {
        // this.logger.debug("chat messages", this.chat.messages.map(m => m.content.title));
        let data = [];
        if(!chat.referenceMessage){ 
            chat.referenceMessage = chat.messages[0];
        }
        if(index<0){
          const indexOfReference = chat.messages.indexOf(chat.referenceMessage);
          const messagesBeforeRef = chat.messages.slice(0, indexOfReference+1);
          const messagesToAdd = messagesBeforeRef.slice(messagesBeforeRef.length+index, messagesBeforeRef.length+index+count+1);
          // this.logger.debug("messages to prepend", messagesToAdd.map(m => m.content.title));
          messagesToAdd.forEach(m => {
            data.push(m);
          });
        }
        else{
          const indexOfReference = chat.messages.indexOf(chat.referenceMessage);
          const messagesToAdd = chat.messages.slice(indexOfReference+index, indexOfReference+index+count);
          // this.logger.debug("messages to append", messagesToAdd.map(m => m.content.title));
          // messagesToAdd.forEach(m => {
          //   data.push(m);
          // });
          data = messagesToAdd;
        }
        return data;
      }
    createMessageWithMessageObject(msgObject): AbstractChatMessage {
        let message: AbstractChatMessage;
        if (msgObject.messageType !== undefined) {
            msgObject.type = msgObject.messageType;
        }
        if (msgObject.type == undefined) {
            console.error("message has no type but wanted to create a message", msgObject);
            return new DictionaryMessage();
        }
        switch (msgObject.type) {
            case "chat":
                message = new ChatMessage();
                break;
            case "dictionary":
                message = new DictionaryMessage();
                break;
            case "leitner":
                message = new LeitnerMessage();
                break;
            case "quiz":
            case "artikelQuiz":
            case "imageQuiz":
            case "translationQuiz":
                message = new QuizMessage();
                break;
            case "":
                message = new ChatMessage();

                break;
        }
        message.setUser(new User(msgObject));
        return message;
    }

}
